import React from 'react';
import { Button } from 'antd';
import CommonListsIndex from '../../components/CommonLists/index';
import adsList from './list';

class Ads extends CommonListsIndex {
  constructor() {
    super();
    this.api = 'ads';
    this.addComponent = ``;
    this.editComponent = ``;
    this.listsComponent = adsList;
  }
  componentDidMount() {
    this.freshQueryList();
    this.editComponent = `/content/ads/id/edit`;
    this.addComponent = `/content/ads/add`;
  }

  freshQueryList = () => {
    this.queryList({});
  };

  render() {
    const ListsComponent = this.listsComponent;
    return (
      <div>
        <div className="tantuer-op">
          <Button type="primary" icon="plus" onClick={this.add}>
            新增
          </Button>
        </div>

        <ListsComponent
          data={this.state.listsData}
          edit={this.edit}
          queryList={this.freshQueryList}
        />
      </div>
    );
  }
}
export default Ads;
